
import React, { useEffect, useState } from "react";
import "./style.css";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import ivrImg from "../assets/img/menu/ivr.png"
import smsImg from "../assets/img/menu/sms.png"
import whatsappImg from "../assets/img/menu/whatsapp1.png"
import rcsImg from "../assets/img/menu/rcs.png"
import emailImg from "../assets/img/menu/email.png"
import LoadingScreen from "react-loading-screen";
import logo from "../assets/img/logo.png";
import { GET_COUNT, DASHBOARD_TOTAL_COUNT, ROLE_SUPER_ADMIN_NAME, ALL_CLIENT_LIST, ALL_CLIENTS_GRAPH, CREDITS_BALANCE_CLIENT,BALANCE_CLIENT_CHNL,CREDITS_BALANCE_REDIS,COMPLETE_CHAT_COUNT } from "../constants"


// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Input,
  Row,
  Col
} from "reactstrap";

// core components
// import Tst, {
//   chartExample1
// } from "../variables/charts.js";
import moment from 'moment';

import axios from 'axios';

import apiService from "../variables/apiService";

var emailSent = [];
var emailRead = [];
var month = [];
var emailDelivered = [];
var smsSent = [];
var smsRead = [];
var smsDelivered = [];
var whatsappSent = [];
var whatsappRead = [];
var rcsRead = [];
var rcsDelivered = [];
var rcsRejected = [];
var ivrRead = [];
var ivrDelivered = [];
var ivrRejected = [];
var smsfailed = [];
var whatsappDelivered = [];
var whatsappFailed = [];

let wtsapbalance =0;
let ivrbalance =0;

let smsbalance =0;
const Dashboard = () => {
  let totaldaycnt = 0
  let totalweekcnt = 0


  const [mnth, setMnth] = useState(1)
  const [smscount, setSmsCount] = useState('')
  const [todaycnt, setTodaycnt] = useState([])
  const [weekcnt, setWeekcnt] = useState([])

  const userObj = localStorage.getItem("menus");
  const user = JSON.parse(userObj);
  const [bigChartData, setbigChartData] = React.useState("emails");
  const [search, setSearch] = useState('')
  const [input, setInput] = useState({ name: "", id: "" })

  const [searchClone, setSearchClone] = useState('')
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [smsbalance,setSmsBalance] = useState(0)
  const [mousecnt,setmousecnt] = useState(false)
  const [creditbal,setCreditbal] =useState([])
  const [completechatcount,setCompletechatcount] = useState(0)
 const getCompleteChatCount = (client_id) => {

  if (!client_id) {
    console.log("Client ID not found");
    return;
  }

  const payload = {
    //client_id: client_id.toString(),
    //user_id: luser?.username || "",
    senderid: luser?.sender_id || ""
  };

  console.log("payload:", payload);

  axios.post(COMPLETE_CHAT_COUNT, payload)
    .then((res) => {
      console.log("API Response:", res.data);
      setCompletechatcount(res?.data?.message?.[0]?.chat_count || 0);
    })
    .catch((err) => {
      console.log("Complete Chat Count Error:", err);
      setCompletechatcount(0);
    });
};





  const changeBgChartData = (name) => {

    setbigChartData(name);
  };

  let loginUser = localStorage.getItem("user");
  let luser = JSON.parse(loginUser);



  useEffect(() => {

    getChannelsCount(luser?.client?.toString());
    getWeekCount(luser?.client?.toString())
    { (luser.role == ROLE_SUPER_ADMIN_NAME ||luser.isreseller==1) && getClients() }
  
    //fetchCreditBalance("Whatsapp",luser?.client)
   // fetchCreditBalance("Ivr",luser?.client)
    fetchCreditBalance("Sms",luser?.client)
    getCreditBalRedis(luser?.client);
    getCompleteChatCount(luser?.client?.toString());


  }, []);

  const getCreditBalRedis=(client_id)=>{

    const payload = {
      client: client_id
    }

    apiService.postData(CREDITS_BALANCE_REDIS, payload).then(res => {
     
      setCreditbal(res?.data)
     // setTodaycnt(res.data)
    }).catch(e => {
      console.log("error===>", e);
    })

  }

  const getChannelsCount = (client_id) => {
    var today = new Date()
    let fromdate = moment(today).format("YYYY-MM-DD");

    const payload = {
      fromdate: fromdate,
      todate: fromdate,
      client_id: client_id.toString(),
      user_id:luser?.username,
      sender_id:luser?.sender_id||""
    }
  
    axios.post(DASHBOARD_TOTAL_COUNT, payload).then(res => {
      setTodaycnt(res.data)
    }).catch(e => {
      console.log("error===>", e);
    })
 
  }

  const getWeekCount = (client_id) => {
    var today = new Date()
    let todate = moment(today).format("YYYY-MM-DD");
    var pastdays = new Date();
    pastdays.setDate(today.getDate() - 6);
    const fromdate = moment(pastdays).format("YYYY-MM-DD");
    const payload = {
      fromdate: fromdate,
      todate: todate,
      client_id: client_id.toString(),
      user_id:luser?.username,
      sender_id:luser?.sender_id||""

    }
    axios.post(DASHBOARD_TOTAL_COUNT, payload).then(res => {
      setWeekcnt(res.data)
      setIsLoading(false)

    }).catch(e => {
      setIsLoading(false)

      console.log("error===>", e);
    })

    getEmails("email", luser?.client)
    getEmails("sms", luser?.client)
    getEmails("whatsapp", luser?.client)
    getEmails("ivr", luser?.client)
    getEmails("rcs", luser?.client)
  }

  const getClients = async () => {
    await axios.get(`${ALL_CLIENT_LIST}?client_id=${luser?.client}`).then(res => {
    
      setClients(res.data.data)
      setSearchClone(res.data.data)
       console.log("clients :: ",res.data.data);

    }).catch(e => console.log("fetching client error==>", e))
  }

  const filterhandle = (e) => {
    const filterd = searchClone.filter(item => item?.company_name?.toLowerCase().includes(e?.target?.value.toLowerCase()))
    setClients(filterd)
    setInput({ id: filterd[0]?.id, name: filterd[0]?.company_name })


  }

  const fetchCreditBalance = async(chnl,clint) => {
    let payload={
     // client : lclStrge?.role==ROLE_SUPER_ADMIN_NAME?credits?.client?.value:lclStrge?.client,
     client : clint,
      channel : chnl
    }
    await axios
    .post(CREDITS_BALANCE_CLIENT,payload)
      .then(res =>{
      
      //  balance =res?.data?.message[0].balance;
      if(chnl=="Whatsapp"){
        wtsapbalance =res?.data[0]?.balance;
      }else if(chnl=="Sms"){
        setSmsBalance(res?.data[0]?.balance)
       // smsbalance=0
       // smsbalance=res?.data[0]?.balance;
        console.log(":2::",smsbalance);
      }else{
         ivrbalance=res?.data[0]?.balance;
      }
      
   
      })
      .catch((e) => {
        console.log("Exception==>", e);
      });
  };


  const getEmails = (chnl, clnt) => {
    emailRead = [];
    emailSent = [];
    const payload = {
      client_id: clnt || 4,
      channel: chnl
    }
    apiService.postData(ALL_CLIENTS_GRAPH, payload).then((res) => {


      res?.data?.message?.map((data) => {
        month.push(data.MONTH_NAME);
        if (chnl === "email") {
          emailRead.push(data.Read);
          emailSent.push(data.Sent);
          emailDelivered.push(data.Delivered);
        } else if (chnl === "sms") {
          smsRead.push(data.Read);

          smsSent.push(data.Sent);
          smsfailed.push(data.failed);

          
          smsDelivered.push(data.Delivered);
        } else if (chnl === "whatsapp") {
          whatsappRead.push(data.Read);

          whatsappSent.push(data.Sent);
          whatsappDelivered.push(data.Delivered);
          whatsappFailed.push(data.Failed);

        } else if (chnl === "rcs") {
          rcsRead.push(data.Read);
          rcsDelivered.push(data.Delivered);
          rcsRejected.push(data.Rejected)
        } else if (chnl === "ivr") {
          ivrRead.push(data.ANSWER);
          // rcsDelivered.push(data.Delivered);
          ivrRejected.push(data.NOANSWER + data.BUSY)
        }

      });

    }).catch(e => console.log(e));
  };
  ///CHART
  let chart_1_2_3_options = {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      backgroundColor: "#f5f5f5",
      titleFontColor: "#333",
      bodyFontColor: "#666",
      bodySpacing: 4,
      xPadding: 12,
      mode: "nearest",
      intersect: 0,
      position: "nearest",
    },
    responsive: true,
    scales: {
      yAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.0)",
            zeroLineColor: "transparent",
          },
          ticks: {
            suggestedMin: 60,
            suggestedMax: 125,
            padding: 20,
            fontColor: "#9a9a9a",
          },
        },
      ],
      xAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.1)",
            zeroLineColor: "transparent",
          },
          ticks: {
            padding: 20,
            fontColor: "#9a9a9a",
          },
        },
      ],
    },
  };

  const fetchdata = (canvas) => {
    let sent = 0;
    let read = 0;
    let rejected = 0
    let deivered = 0
    let failed = 0



    if (bigChartData == "emails") {
      // delete emailSent._chartjs;
      let numbers = emailSent.filter(item => typeof item === 'number');
      sent = numbers;
    } else if (bigChartData == "sms") {
      sent = smsSent;
      failed = smsfailed;

      
    } else if (bigChartData == "whatsapp") {
      sent = whatsappSent;
      deivered = whatsappDelivered
      failed = whatsappFailed
      read = whatsappRead

    } else if (bigChartData == "ivr") {
      sent = ivrRead;
      failed = ivrRejected
    } else if (bigChartData == "rcs") {
      sent = rcsDelivered;
      read = rcsRead
      failed = rcsRejected

    }


    let ctx = canvas.getContext("2d");

    let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

    gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
    gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
    gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors
    //if(bigChartData==="email"){
    return {
      labels: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      datasets: [
        {
          label: "Delivered",
          fill: true,
          backgroundColor: gradientStroke,
          borderColor: "#1f8ef1",
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: "#1f8ef1",
          pointBorderColor: "rgba(255,255,255,0)",
          pointHoverBackgroundColor: "#1f8ef1",
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: deivered,
        },
        {
          label: "Failed",
          fill: true,
          backgroundColor: gradientStroke,
          borderColor: "red",
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: "red",
          pointBorderColor: "rgba(255,255,255,0)",
          pointHoverBackgroundColor: "red",
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: failed,
        },
        {
          label: "Sent",
          fill: true,
          backgroundColor: gradientStroke,
          borderColor: "purple",
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: "purple",
          pointBorderColor: "rgba(255,255,255,0)",
          pointHoverBackgroundColor: "purple",
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: sent,
        },
        {
          label: "Read",
          fill: true,
          backgroundColor: gradientStroke,
          borderColor: "green",
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: "green",
          pointBorderColor: "rgba(255,255,255,0)",
          pointHoverBackgroundColor: "green",
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: read,
        },
      ],
    };
    // }else if(bigChartData==="sms"){
    //   return {
    //     labels: [
    //       "JAN",
    //       "FEB",
    //       "MAR",
    //       "APR",
    //       "MAY",
    //       "JUN",
    //       "JUL",
    //       "AUG",
    //       "SEP",
    //       "OCT",
    //       "NOV",
    //       "DEC",
    //     ],
    //     datasets: [
    //       {
    //         label: "Delivered",
    //         fill: true,
    //         backgroundColor: gradientStroke,
    //         borderColor: "#1f8ef1",
    //         borderWidth: 2,
    //         borderDash: [],
    //         borderDashOffset: 0.0,
    //         pointBackgroundColor: "#1f8ef1",
    //         pointBorderColor: "rgba(255,255,255,0)",
    //         pointHoverBackgroundColor: "#1f8ef1",
    //         pointBorderWidth: 20,
    //         pointHoverRadius: 4,
    //         pointHoverBorderWidth: 15,
    //         pointRadius: 4,
    //         data: smsDelivered,
    //       },
    //       {
    //         label: "Sent",
    //         fill: true,
    //         backgroundColor: gradientStroke,
    //         borderColor: "pink",
    //         borderWidth: 2,
    //         borderDash: [],
    //         borderDashOffset: 0.0,
    //         pointBackgroundColor: "pink",
    //         pointBorderColor: "rgba(255,255,255,0)",
    //         pointHoverBackgroundColor: "pink",
    //         pointBorderWidth: 20,
    //         pointHoverRadius: 4,
    //         pointHoverBorderWidth: 15,
    //         pointRadius: 4,
    //         data: smsSent,
    //       },
    //       {
    //         label: "Read",
    //         fill: true,
    //         backgroundColor: gradientStroke,
    //         borderColor: "green",
    //         borderWidth: 2,
    //         borderDash: [],
    //         borderDashOffset: 0.0,
    //         pointBackgroundColor: "green",
    //         pointBorderColor: "rgba(255,255,255,0)",
    //         pointHoverBackgroundColor: "green",
    //         pointBorderWidth: 20,
    //         pointHoverRadius: 4,
    //         pointHoverBorderWidth: 15,
    //         pointRadius: 4,
    //         data: smsRead,
    //       },
    //     ],
    //   };
    // }

  }
  //CHART END

  const formatNumber = (num) => {
    return new Intl.NumberFormat("en-US", { notation: "compact", compactDisplay: "short" }).format(num);
  };

  return (
    <>
      {luser &&
        <div className="content">
          <Row >
            {(luser.role == ROLE_SUPER_ADMIN_NAME || luser?.isreseller==1) && <Col sm="2" md="2" style={{paddingRight:"0px"}}>
              <div style={{ background: "#fff", padding: "0px", borderRadius: "5px" }}>
              <Input type="text" placeholder="search client.." onChange={filterhandle} style={{borderBottom: "solid"}} />
              <div >
                <ul className="client_names" >
                  {
                    clients?.map((item, index) => {

                      return (<>

                        <li style={{ color: item.status == 0 ? "#1e1e1e " : "orange", background: input.id === item.id && "#e9e6e6", color: input.id === item.id && "#419ef9" }} onClick={() => {
                          setSearch(item.id); getChannelsCount(item.id); getWeekCount(item.id);getCompleteChatCount(item.id); setInput({ id: item.id, name: item.company_name });
                          localStorage.setItem("client", item.id)
                          emailRead = [];
                          emailDelivered = [];
                          emailSent = [];
                          smsRead = [];
                          smsDelivered = [];
                          smsSent = [];
                          whatsappSent = [];
                          rcsDelivered = [];
                          rcsRead = [];
                          rcsRejected = [];
                          ivrRead = [];
                          ivrRejected = [];
                          



                          getEmails("email", item.id)
                          getEmails("sms", item.id)
                          getEmails("whatsapp", item.id)
                          getEmails("ivr", item.id)
                          getEmails("rcs", item.id)
                          fetchCreditBalance("Sms", item.id)
                          getCreditBalRedis(item.id)
                        }}>
                          {item.company_name}
                        </li>

                      </>)
                    })
                  }
                </ul>
              </div>
              </div>
            </Col>
            }
            <Col sm={(luser.role == ROLE_SUPER_ADMIN_NAME || luser?.isreseller==1)? "10" : "12"} md={(luser.role == ROLE_SUPER_ADMIN_NAME|| luser?.isreseller==1) ? "10" : "12"}>
              <Row>
                <Col lg="3" md="6" className="pl-2 pr-1">
                  <Card className="card-stats  box-1 mb-1">
                    <CardBody>
                      <Row>

                        <Col xs="12" >

                          <div className="box-count">
                            <p className="card-category" style={{"float":"left"}}
                             onMouseEnter={() => setmousecnt(true)}
                             onMouseLeave={() => setmousecnt(false)}
                            >Today Messages</p>
                            {todaycnt?.map(item => {
                              totaldaycnt += item?.cnt[0]?.sent || 0
                            })}
                            <CardTitle tag="h4" style={{"float":"right"}}>

                              <b>
                                {
                                isLoading ? <LoadingScreen
                                children=""
                                loading={isLoading}
                                spinnerColor="#9ee5f8"
                                textColor="#676767"
                                size={18}
                                
                              ></LoadingScreen> :  
                              (
                                mousecnt==true?totaldaycnt:formatNumber(totaldaycnt))}</b></CardTitle>
                          </div>

                        </Col>
                        <Col xs='12'>
                        
                          <Row className='text-center'>
                            {

                              todaycnt?.map((item, index) =>
                              (
                                <>
                                  {
                                    item?.channel === "sms"&& item?.cnt[0]?.sent != null ? <Col xs="4">
                                      <img src={smsImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "ivr"&& item?.cnt[0]?.sent != null ? <Col xs="4">
                                      <img src={ivrImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "rcs"&& item?.cnt[0]?.sent != null ? <Col xs="4">
                                      <img src={rcsImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "whatsapp"&& item?.cnt[0].sent != null ? <Col xs="4">
                                      <img src={whatsappImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "email"&& item?.cnt[0].sent != null ? <Col xs="4">
                                      <img src={emailImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : ""

                                  }
                                </>

                              )
                              )
                            }
                          </Row>

                        </Col>


                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6" className="pl-1 pr-1">
                  <Card className="card-stats  box-2 mb-1">
                    <CardBody>
                      <Row>

                        <Col xs="12">
                          <div className="box-count">
                            <p className="card-category" style={{"float":"left"}}
                             onMouseEnter={() => setmousecnt(true)}
                                onMouseLeave={() => setmousecnt(false)}
                                > Weekly Messages </p>
                            {weekcnt?.map(item => {
                              totalweekcnt += item?.cnt[0]?.sent || 0
                            })}
                            <CardTitle tag="h4" style={{"float":"right"}}><b>
                              {
                              isLoading ? <LoadingScreen
                                children=""
                                loading={isLoading}
                                spinnerColor="#9ee5f8"
                                textColor="#676767"
                               
                               
                              ></LoadingScreen>
                              
                              :
                               (mousecnt==true?totalweekcnt:formatNumber(totalweekcnt))}</b></CardTitle>
                          </div>
                        </Col>
                        <Col xs="12">
                          
                          <Row className='text-center'>
                            {

                              weekcnt?.map((item, index) =>
                              (
                                <>
                                  {
                                    item?.channel === "sms"&& item?.cnt[0].sent != null ? <Col xs="4">
                                      <img src={smsImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "ivr"&& item?.cnt[0]?.sent != null ? <Col xs="4">
                                      <img src={ivrImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "rcs"&& item?.cnt[0]?.sent != null ? <Col xs="4">
                                      <img src={rcsImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "whatsapp"&& item?.cnt[0].sent != null ? <Col xs="4">
                                      <img src={whatsappImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : item?.channel === "email"&& item?.cnt[0].sent != null ? <Col xs="4">
                                      <img src={emailImg} width="30px" height="30px" />
                                      <p class="card-category mt-1">{item?.cnt[0]?.sent?(mousecnt==true?item?.cnt[0]?.sent:formatNumber(item?.cnt[0]?.sent)) : 0}</p>
                                    </Col> : ""

                                  }
                                </>

                              )
                              )
                            }
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>

                  </Card>
                </Col>
                <Col lg="3" md="6" className="pl-1 pr-2">
                  <Card className="card-stats  box-3 mb-1">
                    <CardBody>
                      <Row>

                        <Col xs="12" >
                          <div className="box-count">
                            <p className="card-category" style={{"float":"left"}}>Remaining Balance(INR)</p>
                            <CardTitle tag="h4" style={{"float":"right"}}><b>00.00</b></CardTitle>
                          </div>
                        </Col>
                        <Col xs='12'>
                          
                          <Row className='text-center'>
                            <Col xs="4">
                              <img src={smsImg} width="30px" height="30px" />
                              {/* <p class="card-category mt-1">{smsbalance}</p> */}
                              <p class="card-category mt-1">{creditbal?.smsbalance&&creditbal?.smsbalance}</p>
                              <p class="card-category mt-1">0</p>

                            </Col>
                            <Col xs="4">
                              <img src={ivrImg} width="30px" height="30px" />
                              <p class="card-category mt-1">{creditbal?.ivrbalance&&creditbal?.ivrbalance}</p>
                              <p class="card-category mt-1">0</p>
                            </Col>

                            <Col xs="4">
                              <img src={rcsImg} width="30px" height="30px" />
                              <p class="card-category mt-1">{creditbal?.rcsbalance&&creditbal?.rcsbalance}</p>
                              {/* <p class="card-category mt-1">0</p> */}
                            </Col>
                            <Col xs="4">
                              <img src={whatsappImg} width="30px" height="30px" />
                              <p class="card-category mt-1">{creditbal?.whatsappbalance&&creditbal?.whatsappbalance}</p>
                              {/* <p class="card-category mt-1">{wtsapbalance}</p> */}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>

                  </Card>
                </Col>
                <Col lg="3" md="6" className="pl-1 pr-2">
                  <Card className="card-stats box-4 mb-1">
                    <CardBody>
                      <Row>
                        <Col xs="12">
                          <div className="box-count">
                            <p
                              className="card-category"
                              style={{ float: "left" }}
                            >
                              Chat Count
                            </p>

                            <CardTitle
                              tag="h4"
                              style={{ float: "right" }}
                            >
                              <b>{formatNumber(completechatcount)}</b>
                            </CardTitle>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>            

                <Col xs="12" className="pl-2 pr-2">
                  <Card className="card-chart " style={{ "height": "60vh", "marginBottom": "0px" }}>
                    <CardHeader>
                      <Row>

                        <Col sm="12" >
                          <ButtonGroup
                            className="btn-group-toggle float-right"
                            data-toggle="buttons"
                          >

                            {
                              ["emails", "sms", "whatsapp", "ivr", "rcs"]?.map((menus, index) => {

                                return (
                                  <Button
                                    color="info"
                                    id="0"
                                    size="sm"
                                    tag="label"
                                    className={classNames("btn-simple", {
                                      active: bigChartData === menus
                                    })}
                                    onClick={() => { changeBgChartData(menus) }}
                                  >
                                    <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                      {menus}
                                    </span>
                                    <span className="d-block d-sm-none">
                                      <i className="tim-icons icon-single-02" />
                                    </span>
                                  </Button>

                                )
                              })
                            }


                          </ButtonGroup>
                        </Col>
                      </Row>

                    </CardHeader>
                    <CardBody >
                      <div className="chart-area">
                        <Line
                          data={fetchdata}
                          options={chart_1_2_3_options}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Col>



              </Row>
            </Col>
          </Row>


        </div>
      }
    </>
  );
};

export default Dashboard;
